/**
 * 앱 전역 상수.
 *
 * 기존에 hooks/queries 별로 30_000 리터럴이 흩어져 있어 변경 시 누락 위험이
 * 있었다. TanStack Query 가 데이터를 재폴링하는 간격은 한 곳에서 관리한다.
 *
 * 서버 폴링 주기(application.yml 의 bridge-checker.poll-interval-ms)가 60s 이므로
 * 클라이언트 재폴링은 그 절반인 30s — 최대 stale 윈도우를 폴링 주기 한 사이클
 * 안으로 묶기 위함.
 */
export const REFETCH_INTERVAL_MS = 30_000;
